<template>
  <div class="father" style="display: block">
    <div style="width: 100%; text-align: right">
      <el-button
        type="success"
        style="margin-right: 20px; width: 150px"
        @click="dialogChange(true, 'create')"
        >新增</el-button
      >
    </div>
    <div class="center" style="width: 100%">
      <el-table
        ref="wtyTableRef"
        border
        :fit="true"
        :data="ugroup_list"
        size="mini"
        type="index"
        height="300px"
        class="show-table"
        style="height: 100%; width: calc(100% - 20px)"
        :cell-style="{ padding: '0px 0' }"
        :header-cell-style="{
          height: '20px',
          background: '#409eff',
          color: '#fff',
        }"
        @row-click="rowClick"
      >
        <el-table-column type="index" align="center" :width="50">
        </el-table-column>
        <el-table-column
          v-if="who == 'merchant'"
          prop="group_id"
          align="center"
          label="组id"
          fiexd="false"
          width="200"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in wtycolumnList"
          :key="index"
          :prop="item.prop"
          :align="item.align"
          :label="item.label"
          :width="item.width"
          ><!-- formatter 数据过滤 -->
        </el-table-column>

        <el-table-column align="center" width="250" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type=""
              @click="dialogChange(true, 'modify', scope.row)"
              size="mini"
              >修改用户组</el-button
            >
            <el-button
              type="danger"
              @click="dialogChange(true, 'del', scope.row)"
              size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="dialog_title"
      :visible.sync="showdialog"
      width="1000px"
      style="margin-top: 0px"
      top="4vh"
      center
    >
      <div style="display: flex">
        <el-form
          label-width="150px"
          style="min-width: 350px; margin-right: 20px"
        >
          <el-form-item label="用户组号：">
            <el-input
              :disabled="dialog_title == '修改用户组'"
              placeholder="请输入用户组号："
              v-model="user_group.group_no"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户组名称：">
            <el-input
              placeholder="请输入用户组名称："
              v-model="user_group.group_name"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户组状态：">
            <el-switch
              v-model="user_group.flag"
              active-text="正常"
              inactive-text="暂停"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-form>
        <all-permission
          :allp="true"
          :treeData6="treeData6"
          :treeData="treeData"
          ref="allPermissionRef"
          @checkedChange="checkedChange"
          :height="'500'"
        ></all-permission>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSureClick">确 定</el-button>
        <el-button @click="showdialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPermissList,
  createUserGroup,
  getUsergroupList,
  modifyUserGroup,
  getUserGroupPermission,
  setUserGroupPermission,
  deleteUserGroupPermission,
  deleteUsrGroup,
} from "@/api/service.js";

import {
  MusergroupQuery,
  getMerchantPermissList,
  MusergroupList,
  McreateUserGroup,
  MmodifyUserGroup,
  MsetUserGroupPermission,
  MdeleteUserGroupPermission,
  MdeleteUsrGroup,
} from "@/api/merchant.js";

// import { coerceTruthyValueToArray } from "element-ui/src/utils/util";
import allPermission from "@/components/allPermission";

// import dial
export default {
  name: "wty-userGroup",
  inject: ["reload"],
  props: ["who"],
  created() {},
  async mounted() {
    this.treeData = [];
    this.treeData6 = [];
    this.ugroup_list = [];
    if (this.who == "service") {
      //服务商调用组件
      const res = await getPermissList();
      this.treeData = res.t2;
      this.treeData6 = res.t6;
      this.ugroup_list = await getUsergroupList();
    } else if (this.who == "merchant") {
      const res = await getMerchantPermissList();
      this.treeData = res.t2;
      this.treeData6 = res.t6; //所有可以授权的权限
      this.ugroup_list = await MusergroupList();
    }
    // console.log(this.treeData6);
  },
  components: {
    allPermission,
  },
  data() {
    return {
      /**
       * 表格列
       */
      wtycolumnList: [
        {
          prop: "group_no",
          align: "center",
          label: "组号",
          width: "200",
          fixed: false,
        },
        {
          prop: "group_name",
          align: "center",
          label: "组名",
          width: "200",
          fixed: false,
        },
        {
          prop: "oper_no",
          align: "center",
          label: "创建成员",
          width: "200",
          fixed: false,
        },
        {
          prop: "create_time",
          align: "center",
          label: "创建时间",
          width: "300",
          fixed: false,
        },
        {
          prop: "oper_time",
          align: "center",
          label: "修改时间",
          width: "200",
          fixed: false,
        },
      ],
      dialog_title: "", //dialog标题
      showdialog: false, //组设置和修改
      showpermission: false, //权限设置和修改
      //是否新增
      iscreate: true,
      user_group: {
        group_id: "",
        group_no: "",
        group_name: "",
        flag: "1",
      },
      //用户组列表
      ugroup_list: [],
      //选中权限列表
      checked_list: [],
      //老权限列表
      get_checkedlist: [],
      //选中的用户组
      group_hlight: "-1",
      /**
       * 用来循环的权限
       */
      treeData: [],
      /**
       * 所有子权限
       */
      treeData6: [],
      columnList: [
        {
          prop: "merchant_id",
          align: "center",
          label: "店铺ID",
          width: "200",
          fixed: "left",
        },
      ],
      iconList: [
        {
          label: "删除用户组",
          icon: "el-icon-delete-solid",
          style: "color:#F56C6C;",
          showd: false,
          value: "del",
        },
        {
          label: "新建用户组",
          icon: "el-icon-plus",
          style: "color:#67C23A",
          showd: true,
          value: "create",
        },
        {
          label: "修改用户组",
          icon: "el-icon-setting",
          style: "color:#E6A23C;",
          showd: true,
          value: "modify",
        },
        {
          label: "保存授权",
          icon: "el-icon-s-claim",
          style: "color:#409EFF",
          showd: true,
          value: "save",
        },
      ],
    };
  },
  methods: {
    rowClick() {},
    /**
     * all-permission 组件返回选中的权限
     */
    checkedChange(e) {
      this.checked_list = e;
    },
    //高亮显示
    /**
     * @param {String} key 选中的行
     */
    async highLight(key, name, id) {
      this.group_hlight = key;
      this.user_group.group_no = key;
      this.user_group.group_name = name;
      if (id) this.user_group.group_id = id;
      this.updatedGetCheckList();

      // this.treeShow = true;
      // console.log("checkout_list",this.checked_list);
    },
    //权限设置

    //显示model
    /**
     * 控制dialog显示与隐藏
     * @param {Boolean} value 是否显示dialog
     * @param {"create"|"modify"|"del"|"save"} key 可以选择的值
     * @param {Object} group 选中的组
     */
    async dialogChange(value, key, group) {
      const that = this;
      console.log("argumentsdialogChange", arguments);
      if (value == false) this.showdialog = false;
      switch (key) {
        case "create":
          this.showdialog = value;
          this.iscreate = true;
          this.dialog_title = "新建用户组";
          this.group_hlight = "-1";
          this.user_group = {
            group_id: "",
            group_no: "",
            group_name: "",
            flag: "1",
          };
          this.checked_list = [];
          this.$nextTick(() => {
            console.log(this.checked_list);
            that.$refs.allPermissionRef.changeChecked(this.checked_list);
          });
          // this.$refs.allPermissionRef.changeChecked(this.checked_list);
          break;
        case "modify":
          console.log("modify", key);
          this.highLight(group.group_no, group.group_name, group.group_id);
          console.log(this.user_group);
          if (this.who == "service" && this.user_group.group_no == "") {
            this.warnMessage("请先选择用户组！");
            return;
          } else if (this.who == "merchant" && this.user_group.group_id == "") {
            this.warnMessage("请先选择用户组！");
            return;
          }
          this.dialog_title = "修改用户组";
          this.showdialog = value;
          this.iscreate = false;
          break;
        case "del":
          // this.highLight(group.group_no, group.group_name, group.group_id);
          if (this.who == "service" && group.group_no == "") {
            this.warnMessage("请先选择用户组！");
            return;
          } else if (this.who == "merchant" && group.group_id == "") {
            this.warnMessage("请先选择用户组！");
            return;
          }
          //删除用户组
          if (this.who == "service") {
            const del_res = await deleteUsrGroup(group.group_no);
            if (this.testR(del_res)) {
              this.successMessage("删除用户组成功！");
            }
            if (this.testR(del_res)) {
              this.ugroup_list = [];
              this.ugroup_list = await getUsergroupList();
            }
          } else if (this.who == "merchant") {
            const del_res = await MdeleteUsrGroup(group.group_id);
            if (this.testR(del_res)) {
              this.successMessage("删除用户组成功！");
            }
            if (this.testR(del_res)) {
              this.ugroup_list = [];
              this.ugroup_list = await MusergroupList();
            }
          }

          break;
        case "save":
          console.log("save");
          console.log("group", group);
          if (this.who == "service" && group.group_no == "") {
            this.warnMessage("请先选择用户组！");
            return;
          } else if (this.who == "merchant" && group.group_no == "") {
            this.warnMessage("请先选择用户组！");
            return;
          }
          /* console.log(this.checked_list);
          if (this.checked_list.length == 0) {
            this.warnMessage("请选择权限");
            return;
          } */
          var checked_list = [];
          this.treeData6.forEach((item, index, arr) => {
            if (this.checked_list.includes(item.label)) {
              checked_list.push(item.id);
            }
          });
          // this.showdialog = value;
          //如果原来没授过权
          if (this.get_checkedlist.length == 0) {
            var list = [];
            for (let i = 0; i < checked_list.length; i++) {
              //保存权限
              if (this.who == "service") {
                list.push(
                  setUserGroupPermission({
                    description: this.user_group.group_name,
                    permission_no: checked_list[i],
                    group_no: this.user_group.group_no,
                  })
                );
              } else if (this.who == "merchant") {
                list.push(
                  MsetUserGroupPermission({
                    description: this.user_group.group_name,
                    permission_no: checked_list[i],
                    group_id: this.user_group.group_id,
                    group_no: this.user_group.group_no,
                  })
                );
              }
            }
            if (list.length > 0) {
              const [...res] = await Promise.all(list);
              if (this.testR(res[0])) this.successMessage("授权成功！");
              this.updatedGetCheckList();
              return;
            }
          } else {
            /* var del = [],
              add = []; */
            var list = [];
            for (let i = 0; i < this.get_checkedlist.length; i++) {
              if (!checked_list.includes(this.get_checkedlist[i])) {
                if (this.who == "service") {
                  list.push(
                    deleteUserGroupPermission({
                      permission_no: this.get_checkedlist[i],
                      group_no: this.user_group.group_no,
                    })
                  );
                } else if (this.who == "merchant") {
                  list.push(
                    MdeleteUserGroupPermission({
                      permission_no: this.get_checkedlist[i],
                      group_id: this.user_group.group_id,
                      group_no: this.user_group.group_no,
                    })
                  );
                }
              }
            }
            for (let j = 0; j < checked_list.length; j++) {
              if (!this.get_checkedlist.includes(checked_list[j])) {
                if (this.who == "service") {
                  list.push(
                    setUserGroupPermission({
                      permission_no: checked_list[j],
                      group_no: this.user_group.group_no,
                    })
                  );
                } else if (this.who == "merchant") {
                  list.push(
                    MsetUserGroupPermission({
                      permission_no: checked_list[j],
                      group_id: this.user_group.group_id,
                      group_no: this.user_group.group_no,
                    })
                  );
                }
              }
            }
            if (list.length > 0) {
              const [...list_res] = await Promise.all(list);
              // console.log(list_res);
              if (this.testR(list_res[0])) {
                this.successMessage("权限修改完成");
                this.updatedGetCheckList();
              }
            }
          }
          break;
      }
    },
    //创建用户组
    /**
     * 点击模态框确定按钮
     */
    async dialogSureClick() {
      if (this.iscreate) {
        if (!this.user_group.group_no || !this.user_group.group_name) {
          this.warnMessage("请先输入组号、组名");
          return;
        }
        // 创建用户组
        if (this.who == "service") {
          var res = await createUserGroup(this.user_group);
        } else if (this.who == "merchant") {
          var res = await McreateUserGroup(this.user_group);
        }

        if (this.testR(res)) {
          if (
            res.data.return_code == "SUCCESS" &&
            res.data.result_code == "SUCCESS"
          ) {
            this.successMessage(res.data.resp_data.desc);
            let data = {
              group_no: res.data.resp_data.group_no,
              group_name: res.data.resp_data.group_name,
              group_id: res.data.resp_data.group_id,
            };
            this.highLight(data.group_no, data.group_name, data.group_id);
            /*  this.ugroup_list.push(data);
            this.user_group = data; */
            console.log("神抽狗的data", data);
            this.dialogChange(false, "save", data);
            this.getGroupList();
          }
        }
      } else {
        // 修改用户组
        if (this.who == "service") {
          var res = await modifyUserGroup(this.user_group);
        } else if (this.who == "merchant") {
          var res = await MmodifyUserGroup(this.user_group);
        }
        if (this.testR(res)) {
          if (
            res.data.return_code == "SUCCESS" &&
            res.data.result_code == "SUCCESS"
          ) {
            this.successMessage(res.data.resp_data.desc);
            this.ugroup_list = [];
            // 获取所有用户组
            this.getGroupList();
          }
        }
        this.dialogChange(false, "save", this.user_group);
        console.log(
          "这里哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
          this.user_group
        );
      }
    },
    /**
     * 获取所有授权过的用户
     */
    async getGroupList() {
      if (this.who == "service") {
        this.ugroup_list = await getUsergroupList();
        this.dialogChange(false);
      } else if (this.who == "merchant") {
        this.ugroup_list = await MusergroupList();
        this.dialogChange(false);
      }
    },
    /**
     * 将获取到的权限 更新
     */
    async updatedGetCheckList() {
      const that = this;
      if (this.who == "service") {
        console.log(this.who);
        const res = await getUserGroupPermission(this.user_group.group_no);
        this.get_checkedlist = [];
        if (this.testR(res)) {
          for (let i = 0; i < res.data.resp_data.length; i++) {
            this.get_checkedlist.push(res.data.resp_data[i].permission_no);
          }
        }
        //保存老的list
        // this.get_checkedlist = [];
        this.checked_list = [];
        // this.get_checkedlist = this.checked_list;
        this.treeData6.forEach((item, index, array) => {
          if (this.get_checkedlist.includes(item.id)) {
            this.checked_list.push(item.label);
          }
        });
        this.$nextTick(() => {
          that.$refs.allPermissionRef.changeChecked(this.checked_list);
        });
      } else if (this.who == "merchant") {
        //TODO: 店铺获取用户组权限
        console.log(this.who);
        const res = await MusergroupQuery(this.user_group.group_id);
        this.get_checkedlist = [];
        if (this.testR(res)) {
          for (let i = 0; i < res.data.resp_data.length; i++) {
            this.get_checkedlist.push(res.data.resp_data[i].permission_no);
          }
        }
        //保存老的list
        // this.get_checkedlist = [];
        this.checked_list = [];
        // this.get_checkedlist = this.checked_list;
        this.treeData6.forEach((item, index, array) => {
          if (this.get_checkedlist.includes(item.id)) {
            this.checked_list.push(item.label);
          }
        });
        this.$nextTick(() => {
          that.$refs.allPermissionRef.changeChecked(this.checked_list);
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog .el-dialog--center {
  margin-top: 2vh !important;
}
.father {
  padding: 10px;
}
/* .item-main {
  height: 100%;
  min-height: 600px;
} */
.left {
  width: 25%;
}

.ap-fa {
  overflow: hidden;
  // background-color: rgb(228, 66, 66);
  width: auto;
  padding: 0 20px;
  margin-left: 50px;
}
.center {
  width: 35%;
  // background-color: purple;
  .center-title {
    width: 100%;
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    padding: 0 20px;
    .add {
      width: 30px;
      height: 30px;
      // background-color: #eaeaea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      font-weight: 700;
      margin: 10px;
    }
  }
  .center-body {
    height: calc(100% - 100px);
    /* min-height: 580px;
    max-height: 580px; */
    // background-color: pink;
    .center-item {
      width: 90%;
      height: auto;
      max-height: 100px;
      background-color: rgba(0, 0, 0, 0.025);
      margin: 10px;
      float: left;
      display: flex;
      // flex-direction: column;
      // align-items: center;
      justify-content: center;
      border-radius: 10px;
      font-size: 20px;
      cursor: pointer;
      /* .close {
        width: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        background-color:#ff7373;
        border-radius:0 10px 10px 0;

      } */
    }

    .center-item-checked {
      background-color: #409eff;
      color: #fff;
    }
  }
}
.el-checkbox__label {
  font-size: 24px !important;
}
.el-form-item__label {
  font-size: 24px !important;
}
</style>
